module.exports = "pegasus/assets/themelp1/travel/100.png";